module.exports = __webpack_public_path__ + "static/media/phone-square-alt-solid.67fc332f.svg";